<button type="button" id="btnAutoLoad" (click)="LoadSummaryData()" style="display:none">Add</button>
<button type="button" id="btnLoadList" (click)="LoadGridData()" style="display:none">Get</button>
<div class="row" id="divSummaryIndex">
  <div class="col-12 col-sm-7 col-md-2">
    <div class="info-box">
      <span class="info-box-icon bg-blue elevation-1"><i class="fas fa-calendar"></i></span>
      <div class="info-box-content">
        <span class="info-box-number">Overall</span>
        <span class="info-box-text">{{OverAllArticles}} Articles</span>
        <span class="info-box-text">{{OverAllPages}} Pages</span>
        <span class="info-box-text"> {{OverAllBatch}}</span>
      </div>

    </div>
  </div>

  <div class="col-12  col-sm-7 col-md-2">
    <div class="info-box mb-3">
      <span class="info-box-icon bg-yellow elevation-1"><i class="fas fa-calendar-alt"></i></span>
      <div class="info-box-content">
        <span class="info-box-number">Today ({{today | date:'dd MMM'}})</span>
        <span class="info-box-text">{{TodayArticles}} Articles</span>
        <span class="info-box-text">{{TodayPages}} Pages</span>
        <span class="info-box-text"> {{TodayBatch}}</span>

      </div>
    </div>
  </div>

  <div class="col-12  col-sm-7 col-md-2">
    <div class="info-box mb-3">
      <span class="info-box-icon bg-orange elevation-1"><i class="fas fa-calendar-check"></i></span>
      <div class="info-box-content">
        <span class="info-box-number">Yesterday ({{yesterday | date:'dd MMM'}})</span>
        <span class="info-box-text">{{YesterdayArticles}} Articles</span>
        <span class="info-box-text">{{YesterdayPages}} Pages</span>
        <span class="info-box-text"> {{YesterdayBatch}}</span>

      </div>
    </div>
  </div>
  <div class="col-12  col-sm-7 col-md-2">
    <div class="info-box mb-3">
      <span class="info-box-icon bg-purple elevation-1"><i class="fas fa-calendar-day"></i></span>
      <div class="info-box-content">
        <span class="info-box-number">Current Month ({{today | date:'MMM'}})</span>
        <span class="info-box-text">{{CurrentMonthArticles}} Articles</span>
        <span class="info-box-text">{{CurrentMonthPages}} Pages</span>
        <span class="info-box-text"> {{CurrentMonthBatchCount}}</span>

      </div>
    </div>
  </div>
  <div class="col-12  col-sm-7 col-md-2">
    <div class="info-box mb-3">
      <span class="info-box-icon bg-green elevation-1"><i class="fas fa-calendar-week"></i></span>
      <div class="info-box-content">
        <span class="info-box-number">Previous Month ({{previousMonth | date:'MMM'}})</span>
        <span class="info-box-text">{{PreviousMonthArticles}} Articles</span>
        <span class="info-box-text">{{PreviousMonthPages}} Pages</span>
        <span class="info-box-text"> {{PreviousMonthBatchCount}}</span>

      </div>
    </div>
  </div>

  <div class="col-12  col-sm-7 col-md-2">

    <div class="info-box mb-3">
      <span class="info-box-icon bg-red elevation-1"><i class="fas fa-calendar-plus"></i></span>
      <div class="info-box-content">
        <span class="info-box-number">Current Year ({{today | date:'yyyy'}})</span>
        <span class="info-box-text">{{CurrentYearArticles}} Articles</span>
        <span class="info-box-text">{{CurrentYearPages}} Pages</span>
        <span class="info-box-text"> {{CurrentYearBatchCount}}</span>

      </div>
    </div>
  </div>


</div>
<div class="row">
  <div class="col-6">
    <div class="col-12 text-center">
      <label>NT Inprocess Articles</label>
    </div>
    <div class="form-group col-12">
      <table #dataTable class="display" style="width:100%"></table>
    </div>
  </div>
  <div class="col-6">
    <div class="col-12 text-center">
      <label>Vendor Inprocess Articles</label>
    </div>
    <div class="form-group col-12">
      <table #dataTableVendor class="display" style="width:100%"></table>
    </div>
  </div>
</div>
<div class="col-12 text-center">
  <label class="lblBenchMarkData">{{this.modelItem.BenchMarkPages}}</label>
</div>

<!--<div class="row">
  <div class="col-sm-12">
    <div class="form-group fixTableHead" id="divWorkflow" style="margin-left:20px;margin-top:20px;margin-right:20px;">
      <table id="tblWorkflow" class="dataTable table" style="width: 100%; white-space: normal !important">
        <thead>
          <tr>
            <th>Status</th>
            <th>Received</th>
            <th>Batch</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b>Over all</b></td>
            <td>
              {{OverAllArticles}} Articles &nbsp;
              {{OverAllPages}} Pages
            </td>
            <td>
              {{OverAllBatch}}
            </td>
          </tr>
          <tr>
            <td><b>Today ({{today | date:'dd MMM'}}) </b></td>
            <td>
              {{TodayArticles}}  Articles &nbsp;
              {{TodayPages}} Pages
            </td>
            <td>
              {{TodayBatch}}
            </td>
          </tr>
          <tr>
            <td><b>Yesterday ({{yesterday | date:'dd MMM'}})</b></td>
            <td>
              {{YesterdayArticles}} Articles &nbsp;
              {{YesterdayPages}} Pages
            </td>
            <td>
              {{YesterdayBatch}}
            </td>
          </tr>
          <tr>
            <td><b>Current Month ({{today | date:'MMM'}})</b></td>
            <td>
              {{CurrentMonthArticles}} Articles &nbsp;
              {{CurrentMonthPages}} Pages
            </td>
            <td>
              {{CurrentMonthBatchCount}}
            </td>
          </tr>
          <tr>
            <td><b>Previous Month ({{previousMonth | date:'MMM'}})</b></td>
            <td>
              {{PreviousMonthArticles}} Articles &nbsp;
              {{PreviousMonthPages}} Pages
            </td>
            <td>
              {{PreviousMonthBatchCount}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

</div>-->
